import { useState, useContext, useCallback, useEffect } from 'react';
import CustomDialog from '../ui/feedback/CustomDialog';
import useSessionStorage from '../../hooks/useSessionStorage.js';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import * as TestStatus from './TestStatus.js';
import * as Storage from '../common/Storage.js';
import {
  setFullscreen,
  switchToFullscreen,
  clearClipboard,
} from '../../scripts/less-secure/enforceLessSecure.js';
import { useTranslation } from 'react-i18next';
/**
 *
 * @param {Object} props The properties for the component
 * @param {boolean} props.message Message to display in the dialog.
 * @param {boolean} props.title Title of the dialog
 * @returns
 */
const AwaitingLaunchDialog = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const { getStorageItem } = useSessionStorage();
  const { updateTestStatus } = useContext(AssessmentContext);
  const { t } = useTranslation();

  const proceedHandler = useCallback(async () => {
    await clearClipboard();
    //1. force fullscreen
    await switchToFullscreen();
    setFullscreen(true); //set to fullscreen manually since the fullscreenApiChange listener is not subscribed until after test:start
    //2. update test status
    updateTestStatus(TestStatus.TEST_LAUNCHED);
    //3.close dialog
    setOpenDialog(false);
  }, [updateTestStatus]);

  useEffect(() => {
    let pnp = getStorageItem(Storage.STORAGE_PNP);
    //DEV-ONLY: enable out of focus by adding a ! to the condition below
    if (pnp?.screenReader) {
      //no need to enforce fullscreen, load the test
      updateTestStatus(TestStatus.TEST_LAUNCHED);
    } else {
      //open dialog to inform user we are putting it in fullscreen mode
      setOpenDialog(true);
    }
  }, [getStorageItem, updateTestStatus]);

  return (
    openDialog && (
      <CustomDialog
        open={true}
        dialogProps={{
          title: t('components.awaitingLaunchDialog.title'),
          message: t('components.awaitingLaunchDialog.message'),
          actions: [
            {
              label: t('components.awaitingLaunchDialog.proceed'),
              handle: proceedHandler,
            },
          ],
        }}
      />
    )
  );
};

export default AwaitingLaunchDialog;
